import { Injectable } from '@angular/core';
import { GenericService } from '@messaia/cdk';
import { CustomerTariffChange } from '../models/customer-tariff-change';

@Injectable({ providedIn: 'root' })
export class CustomerTariffChangeService extends GenericService<CustomerTariffChange> {

    /**
     * Constructor
     */
    constructor() {
        super('customerTariffChange');
    }
}